__turbopack_context__.v({
  "after": "BeforeAfter-module-scss-module__kMME3W__after",
  "caption": "BeforeAfter-module-scss-module__kMME3W__caption",
  "compare": "BeforeAfter-module-scss-module__kMME3W__compare",
  "frame": "BeforeAfter-module-scss-module__kMME3W__frame",
  "knob": "BeforeAfter-module-scss-module__kMME3W__knob",
  "line": "BeforeAfter-module-scss-module__kMME3W__line",
  "range": "BeforeAfter-module-scss-module__kMME3W__range",
  "tag": "BeforeAfter-module-scss-module__kMME3W__tag",
  "tagAfter": "BeforeAfter-module-scss-module__kMME3W__tagAfter",
  "tagBefore": "BeforeAfter-module-scss-module__kMME3W__tagBefore",
});
